module.exports = __webpack_public_path__ + "img/pay-extra.792a83b7.png";